(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["patoune-hd"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-hm-catalogue]').forEach(root => {
    const panels = [...root.querySelectorAll('[data-hm-product-panel]')];
    const links = [...root.querySelectorAll('[data-hm-product-choice]')];
    if (panels.length < 2) return;
    const select = (panel, writeUrl = false) => {
      panels.forEach(item => { item.hidden = item !== panel; });
      links.forEach(link => link.setAttribute('aria-current', String(link.dataset.hmProductChoice === panel.dataset.hmProductPanel)));
      if (writeUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('product', panel.dataset.hmHandle);
        const selected = panel.querySelector('input[name="variant"]:checked');
        if (selected) url.searchParams.set('variant', selected.value);
        window.history.replaceState(null, '', url);
        document.querySelectorAll('[data-hm-return]').forEach(input => { input.value = url.pathname + url.search; });
      }
    };
    const restore = () => {
      const params = new URL(window.location.href).searchParams;
      const handle = params.get('product');
      const id = params.get('variant');
      const target = panels.find(panel => [...panel.querySelectorAll('input[name="variant"]')].some(input => input.value === id)) || panels.find(panel => panel.dataset.hmHandle === handle) || panels[0];
      if (target) select(target);
    };
    links.forEach(link => link.addEventListener('click', event => {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      const target = panels.find(panel => panel.dataset.hmProductPanel === link.dataset.hmProductChoice);
      if (!target) return;
      event.preventDefault();
      select(target, true);
    }));
    window.addEventListener('pageshow', restore);
    window.addEventListener('popstate', restore);
    restore();
  });

  } catch(e) { console.error(e); }
})();
})();
